/*@ngInject*/
const ToggleButtonController = function ($scope, $element) {

    this.$onInit = function () {
        this.uniqueComponentClass = this.className + 'ToggleButtonComponent';

        $element.addClass('umToggleButton');
        $element.addClass(this.uniqueComponentClass);
    };

    this.handleToggleButtonClick = function () {
        this.value = !this.value;
        this.onChange({value: this.value});
    };
};

angular.module('umCore')
    .controller('umToggleButtonController', ToggleButtonController);

module.exports = ToggleButtonController;
